import { render, staticRenderFns } from "./partnersWithdrawals.vue?vue&type=template&id=e9dbd876"
import script from "./partnersWithdrawals.vue?vue&type=script&lang=js"
export * from "./partnersWithdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports